// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1FkUc","dragIcon":"Choice_dragIcon__lXFrU","left":"Choice_left__3h--T","input":"Choice_input__1u-FW"};